import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../../modules/infra/i18n';

const TotalSalesBreakdownButton = ({ active, ...props }) => (
  <button className="c-btn u-1/1" type="button" {...props}>
    {active ? t('reports:breakdown.hide_breakdown') : t('reports:breakdown.show_breakdown')}
  </button>
);
TotalSalesBreakdownButton.propTypes = {
  active: PropTypes.bool.isRequired,
};

export default TotalSalesBreakdownButton;
